// extracted by mini-css-extract-plugin
export var actionButton = "_re-0";
export var actionMenuContainer = "_re-i";
export var bubble = "_re-2";
export var bubbleActionMenu = "_re-j";
export var bubbleContext = "_re-6";
export var bubbleItems = "_re-7";
export var customer = "_re-3";
export var divider = "_re-8";
export var fileList = "_re-9";
export var hiddenComment = "_re-o";
export var infoAbove = "_re-a";
export var internal = "_re-4";
export var lightActionButton = "_re-1";
export var link = "_re-b";
export var merchant = "_re-5";
export var message = "_re-c";
export var profilePicture = "_re-e";
export var quillToolbarContainer = "_re-f";
export var senderDate = "_re-g";
export var senderDateCustomer = "_re-h";
export var senderName = "_re-d";
export var time = "_re-k";
export var uploadedImage = "_re-l";
export var username = "_re-m";
export var xsmall = "_re-n";